import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Button } from '../../../components/Button/Button'
import { useNavigate } from 'react-router-dom'
import PrizeBadge from '../../../components/ScopedBlock/PrizeBadge.svg?url'

export const CollaborationUpsell: React.FC = () => {
  const navigate = useNavigate()

  const handleUpgradePlanClick = () => {
    navigate('/account/plan/plan')
  }

  return (
    <Container className='p-0'>
      <Row className='zocks-mb-2.5 collaboration-disabled-container gap-5'>
        <Col xs={12} lg>
          <div className='d-flex flex-column gap-3'>
            <h5>Upgrade to unlock this feature</h5>
            <div className='d-flex flex-column gap-2'>
              <div className='d-flex gap-3 align-items-center'>
                <i className='bi bi-check-circle-fill' />
                <div className='label-medium'>Collaborate with your team members</div>
              </div>
              <div className='d-flex gap-3 align-items-center'>
                <i className='bi bi-check-circle-fill' />
                <div className='label-medium'>Control who can discover your meetings</div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} lg className='d-flex flex-column justify-content-center align-items-lg-end'>
          <div className='d-flex'>
            <Button variant='primary' onClick={handleUpgradePlanClick}>
              Upgrade plan <img alt='Upgrade' src={PrizeBadge} />
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
